import { writable } from 'svelte/store'

const MESSAGE_INTERVAL_IN_MINUTES = 1.0
const MESSAGE_INTERVAL_IN_MS = MESSAGE_INTERVAL_IN_MINUTES * 60000

class User {
    username = ''
    messageCount = 1
    firstMessage = Date.now()
    lastMessage = Date.now()

    constructor(username) {
        this.username = username
    }

    getMessageRate() {
        const currentTime = Date.now()
        const startTime = this.firstMessage
        const diff = currentTime - startTime
        const diffMins = Math.round(
            ((diff % 86400000) % 3600000) / MESSAGE_INTERVAL_IN_MS
        )
        if (diffMins === 0) return this.messageCount
        return Math.round(this.messageCount / diffMins)
    }
}

function createStore() {
    const { subscribe, set, update } = writable({})

    return {
        subscribe,
        set: (data) => {
            set(data)
        },
        add: (data) => {
            update((store) => {
                const newStore = {
                    ...store,
                }
                if (!newStore[data.username]) {
                    newStore[data.username] = new User(data.username)
                    return newStore
                }

                newStore[data.username].lastMessage = Date.now()
                newStore[data.username].messageCount++
                return newStore
            })
        },
        remove: (username) => {
            update((store) => {
                const newStore = {
                    ...store,
                }
                delete newStore[username]
                return newStore
            })
        },
    }
}

export const ircStore = createStore()
